window.addEventListener("DOMContentLoaded", () => {
  if (window.location.href.includes("/products/")) {
    document
      .getElementById("cart-icon-bubble")
      .addEventListener("click", function () {
        fetch("/cart?section_id=cart-drawer")
          .then((response) => response.text())
          .then((data) => {
            console.log(data);
            // Handle the response data as needed

            const cartForm = new DOMParser()
              .parseFromString(data, "text/html")
              .querySelector("#CartDrawer .drawer__inner").innerHTML;

            document.querySelector("#CartDrawer .drawer__inner").innerHTML =
              cartForm;

            if (
              document
                .querySelector("cart-drawer")
                .classList.contains("is-empty")
            ) {
              document
                .querySelector("cart-drawer")
                .classList.remove("is-empty");
              document
                .querySelector("cart-drawer-items")
                .classList.remove("is-empty");
              document.querySelector("#CartDrawer-Checkout").disabled = false;
            }

            var emblaNode = document.querySelector(".embla-cart");
            var emblaViewport = emblaNode.querySelector(".embla__viewport");
            var options = { draggable: true, loop: true, align: "start" };

            // Grab button nodes
            const prevButtonNode = document.querySelector(".embla__prev");
            const nextButtonNode = document.querySelector(".embla__next");

            var embla = EmblaCarousel(emblaViewport, options);

            embla.on("settle", () => {
              worksBestPopup.forEach((el) => {
                el.classList.add("hidden");
              });
            });

            prevButtonNode.addEventListener("click", embla.scrollPrev, false);
            nextButtonNode.addEventListener("click", embla.scrollNext, false);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
  }
});
